/**
 * tab保存的共享数据
 * @type {{}}
 */
const tabShareData = {}

const rotueItems = [
  {
    id: 10000000,
    name: '首页',
    meta: { title: '首页' },
    icon: 'icon-a-1_shouye',
    url: '/home',
    menu_show: true,
    component: () => import('@/views/home/index')
  },
  {
    id: 11000000,
    name: '权限管理',
    meta: { title: '权限管理' },
    icon: 'icon-quanxian',
    url: '/rights',
    menu_show: true,
    component: () => import('@/views/rights/index'),
    children: [
      {
        id: 11010000,
        name: '客户管理',
        meta: { title: '客户管理' },
        url: 'customer',
        menu_show: true,
        component: () =>
          import('@/views/rights/customer/list')
      },
      {
        id: 11020000,
        name: '供应商管理',
        meta: { title: '供应商管理' },
        url: 'supplier',
        menu_show: true,
        component: () => import('@/views/rights/supplier/list')
      },
      {
        id: 11030000,
        name: '用户管理',
        meta: { title: '用户管理' },
        url: 'user',
        menu_show: true,
        component: () => import('@/views/rights/user/list')
      },
      {
        id: 11040000,
        name: '角色管理',
        meta: { title: '角色管理' },
        url: 'role',
        menu_show: true,
        component: () => import('@/views/rights/role/list')
      }
    ]
  },
  {
    id: 12000000,
    name: '设备管理',
    meta: { title: '设备管理' },
    icon: 'icon-shezhi-14',
    url: '/equips',
    menu_show: true,
    component: () => import('@/views/equips/index'),
    children: [
      // 病例列表
      {
        id: 12010000,
        name: '设备列表',
        meta: { title: '设备列表' },
        url: 'equip',
        menu_show: true,
        component: () => import('@/views/equips/equip/list')
      },
      {
        id: 12020000,
        name: '参数列表',
        meta: { title: '参数列表' },
        url: 'params',
        menu_show: true,
        component: () => import('@/views/equips/params/index')
      }
    ]
  },
  {
    id: 13000000,
    name: '报警管理',
    meta: { title: '报警管理' },
    icon: 'icon-alarm-full',
    url: '/warning',
    menu_show: true,
    component: () => import('@/views/warning/index'),
    children: [
      {
        id: 13010000,
        name: '报警设置',
        meta: { title: '报警设置' },
        url: 'setup',
        menu_show: true,
        component: () => import('@/views/warning/setup/list')
      },
      {
        id: 13020000,
        name: '实时报警',
        meta: { title: '实时报警' },
        url: 'realtime',
        menu_show: true,
        component: () => import('@/views/warning/realtime/list')
      }
    ]
  },
  {
    id: 14000000,
    name: '任务管理',
    meta: { title: '任务管理' },
    icon: 'icon-renwu1',
    url: '/tasks',
    menu_show: true,
    component: () => import('@/views/tasks/index'),
    children: [
      {
        id: 14010000,
        name: '任务列表',
        meta: { title: '任务列表' },
        url: 'task',
        menu_show: true,
        component: () => import('@/views/tasks/task/list')
      }
    ]
  },
  {
    id: 15000000,
    name: '版本管理',
    meta: { title: '版本管理' },
    icon: 'icon-banbenguanli',
    url: '/versions',
    menu_show: true,
    component: () => import('@/views/versions/index'),
    children: [
      // 版本列表
      {
        id: 15010000,
        name: '版本列表',
        meta: { title: '版本列表' },
        url: 'version',
        menu_show: true,
        component: () => import('@/views/versions/version/list')
      }
    ]
  },
  {
    id: 16000000,
    name: '记录通知',
    meta: { title: '记录通知' },
    icon: 'icon-lishijilu1',
    url: '/records',
    menu_show: true,
    component: () => import('@/views/records/index'),
    children: [
      {
        id: 16010000,
        name: '控制记录',
        meta: { title: '控制记录' },
        url: 'control',
        menu_show: true,
        component: () => import('@/views/records/control/list')
      },
      {
        id: 16020000,
        name: '升级记录',
        meta: { title: '升级记录' },
        url: 'update',
        menu_show: true,
        component: () => import('@/views/records/update/list')
      },
      {
        id: 16030000,
        name: '短信发送记录',
        meta: { title: '短信发送记录' },
        url: 'message',
        menu_show: true,
        component: () => import('@/views/records/message/list')
      },
      {
        id: 16040000,
        name: '平台操作记录',
        meta: { title: '平台操作记录' },
        url: 'operation',
        menu_show: true,
        component: () => import('@/views/records/operation/list')
      }
    ]
  },
  {
    id: 17000000,
    name: '统计',
    meta: { title: '统计' },
    icon: 'icon-tongjixinxi',
    url: '/statistical',
    menu_show: true,
    component: () => import('@/views/statistical/index'),
    children: [
      {
        id: 17010000,
        name: '制片统计',
        meta: { title: '制片统计' },
        url: 'production',
        menu_show: true,
        component: () => import('@/views/statistical/production/list')
      },
      {
        id: 17020000,
        name: '报警统计',
        meta: { title: '报警统计' },
        url: 'alarm',
        menu_show: true,
        component: () => import('@/views/statistical/alarm/list')
      },
      {
        id: 17030000,
        name: 'AI分析统计',
        meta: { title: 'AI分析统计' },
        url: 'ai_analysis',
        menu_show: true,
        component: () => import('@/views/statistical/ai_analysis/list')
      },
      {
        id: 17040000,
        name: '扫描统计',
        meta: { title: '扫描统计' },
        url: 'scan',
        menu_show: true,
        component: () => import('@/views/statistical/scan/list')
      }
    ]
  }
]

// function getGlobalRoutes () {
//   function mapRoutes (d) {
//     return d.map((it) => {
//       return {
//         path: it.url,
//         url: it.url,
//         name: it.name,
//         title: it.meta.title,
//         component: it.component,
//         children: it.children || ''
//       }
//     })
//   }
//   const data = mapRoutes(rotueItems)

//   function mapAllRoutes (d) {
//     d.forEach((item) => {
//       if (item.children) {
//         item.children = mapRoutes(item.children)
//         mapAllRoutes(item.children)
//       }
//     })
//   }
//   mapAllRoutes(data)
//   return data
// }
function getGlobalRoutes () {
  const m = []

  function getSubRoutes (src, dst) {
    for (let i = 0; i < src.length; i++) {
      const item = src[i]
      if (item.component) {
        const a = {
          path: item.url,
          name: item.name,
          title: item.meta.title,
          component: item.component
        }
        if (item.url) a.url = item.url
        if (item.props) a.props = item.props
        dst.push(a)
      }
      if (item.children) {
        getSubRoutes(item.children, dst)
      }
    }
  }

  getSubRoutes(rotueItems, m)
  return m
}

/**
 * 获取权限菜单
 * @param rights
 * @returns
 */
function getRightMenus (rights) {
  // 根据权限动态生成菜单
  function getRightMenu (src, dst) {
    for (let i = 0; i < src.length; i++) {
      const item = src[i]
      if (item.menu_show && (item.id === -1 || rights.indexOf('' + item.id) > -1)) {
        const a = {
          id: item.id,
          name: item.name,
          title: item.meta.title,
          icon: item.icon
        }
        if (item.url) a.url = item.url
        dst.push(a)
        if (item.children) {
          a.children = []
          getRightMenu(item.children, a.children)
        }
      }
    }
  }

  const r_m = []

  getRightMenu(rotueItems, r_m)

  return r_m
}

/**
 * 根据url搜索路由配置
 * @param url
 * @returns 找到的路由配置
 */
function findMenuByUrl (url) {
  function findByUrl (menu) {
    for (let i = 0; i < menu.length; i++) {
      const item = menu[i]
      if (item.url === url) return item
      if (item.children) {
        const r = findByUrl(item.children)
        if (r) return r
      }
    }
    return null
  }

  return findByUrl(rotueItems)
}

function initTab (tablename, data) {
  if (tablename in tabShareData) {
    data = tabShareData[tablename]
    console.log('load data from cache', data)
  } else {
    tabShareData[tablename] = data
  }
  return data
}

function clearTabShareData () {
  for (var k in tabShareData) delete tabShareData[k]
}

export default {
  tabShareData,
  clearTabShareData,
  getRightMenus,
  findMenuByUrl,
  getGlobalRoutes,
  initTab
}
